import React from 'react';
import { initialSteps } from './initialSteps';
import FormContainer from '../../components/Form/FormContainer';
import { formTypes } from '../../constants';

const IdentificationForm = props => (
  <FormContainer
    initialSteps={initialSteps}
    serviceType={formTypes.EIDENTIFICATION}
    {...props}
  />
);

export default IdentificationForm;
